export const contactsProfileTypeFilters = Object.freeze({
  CHILD: 'child',
  BOY: 'boy',
  GIRL: 'girl',
  GUARDIAN: 'guardian',
  EMPLOYEE: 'employee',
});
